import type { IconSvgObject } from './types';

const Books02Icon: IconSvgObject = [
  ["path", { d: "M3 4.50001H16.5C17.3284 4.50001 18 5.17158 18 6.00001V7.99999C18 8.82842 17.3284 9.49999 16.5 9.49999H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9.50001H19.5C20.3284 9.50001 21 10.1716 21 11V13C21 13.8284 20.3284 14.5 19.5 14.5H13M3 14.5H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 14.5H8M3 19.5H16.5C17.3284 19.5 18 18.8284 18 18V16C18 15.1716 17.3284 14.5 16.5 14.5H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 9.50001V16.5L10.5 14.5L13 16.5V9.50001", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Books02Icon;
